import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=7a95cd28&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=7a95cd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a95cd28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a95cd28')) {
      api.createRecord('7a95cd28', component.options)
    } else {
      api.reload('7a95cd28', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=7a95cd28&scoped=true&", function () {
      api.rerender('7a95cd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/udm/Index.vue"
export default component.exports